import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_ALERTS_SALDO: MijnRoute = {
    path: 'saldo-notificatie',
    navigationEvent: 'toSaldoNotificaties',
    regex: /^\/zelf-regelen\/notificaties-beheren\/saldo-notificatie$/,
    webcomponent: 'mijn-klant-notificatie-beheer-webcomponent',
    internalPath: '/saldo-notificatie'
};
